import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid, DataGridElement } from '../../../../../lib/components/compound/dataGrid';
import { KeyofNamespace } from '../../../../../translations/keyofNs';
import { Box, Switch, Typography } from '@mui/material';
import { countryLabel } from '../../../../../misc/countries';

interface Props {
  address?: Record<string, string | number | null | undefined>;
  equal: boolean | undefined;
}

export const PaymentDataAddressView: FC<Props> = ({ address, equal }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage;

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }} marginBottom={2}>
        <Switch checked={equal} disabled name={'equalAddress'} />
        <Typography align="center" height={'auto'}>
          {t('payment:equal_address')}
        </Typography>
      </Box>
      <DataGrid>
        {(address &&
          Object.keys(address).map((key, index) => (
            <DataGridElement
              key={index}
              title={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              // The column stores alpha-2; show the country name, not a bare "DE".
              value={
                key === 'country'
                  ? countryLabel(address[key] as string | null | undefined, language)
                  : address[key] || ''
              }
            />
          ))) ||
          []}
      </DataGrid>
    </>
  );
};
